import { useMemo } from 'react';
import { useBuckets } from './api/use-get-buckets';
import { logAndThrowError } from '../utils/errors';
// Hook to get categories with buckets
export const useArchivedBuckets = () => {
    const buckets = useBuckets();
    return useMemo(() => {
        return buckets.filter((bucket) => bucket.archived);
    }, [buckets]);
};
// Hook to create a bucket request from an assignment request
export const useAssignmentToBucketRequest = (bucketId) => {
    const buckets = useBuckets();
    return (request) => {
        const bucketToUpdate = buckets.find((env) => env.id === bucketId);
        if (!bucketToUpdate) {
            logAndThrowError('Bucket not found');
        }
        // Create a shallow copy of the bucket object
        const updatedBucket = { ...bucketToUpdate };
        // Create a new array for assignments to ensure a new reference
        const updatedAssignments = [...updatedBucket.assignments];
        // Find an existing assignment
        const existingAssignmentIndex = updatedAssignments.findIndex((assign) => assign.year === request.year && assign.month === request.month);
        // Update or create the assignment
        if (existingAssignmentIndex !== -1) {
            // Update the assignment by creating a new assignment object
            updatedAssignments[existingAssignmentIndex] = {
                ...updatedAssignments[existingAssignmentIndex],
                amount: request.amount,
            };
        }
        else {
            // Add the new assignment
            updatedAssignments.push({
                year: request.year,
                month: request.month,
                amount: request.amount,
            });
        }
        // Return the updated bucket with a new assignments array
        return {
            ...updatedBucket,
            assignments: updatedAssignments,
        };
    };
};
/**
 * Options for selecting monthly recurrence intervals in the UI.
 * Each option pairs a number of months with its human-readable label.
 */
export const monthIntervalSelectOptions = [
    { value: '0', label: 'Never' },
    { value: '1', label: 'Every Month' },
    { value: '2', label: 'Every 2 Months' },
    { value: '3', label: 'Every 3 Months' },
    { value: '4', label: 'Every 4 Months' },
    { value: '6', label: 'Every 6 Months' },
    { value: '12', label: 'Every Year' },
    { value: '24', label: 'Every 2 Years' },
];
/**
 * Simple filter function for Command component searching.
 * Performs case-insensitive substring matching after trimming whitespace.
 *
 * @param value - The string value to be matched against
 * @param search - The search query to look for
 * @returns 1 if the value contains the search query (case-insensitive), 0 otherwise
 */
export const bucketFilter = (value, search) => {
    return value.toLowerCase().includes(search.trim().toLowerCase()) ? 1 : 0;
};
